[
  {
    "id": "Green Slime",
    "name": "Green Slime",
    "hp": 24,
    "damage": 5,
    "speed": 0,
    "xp": 3,
    "image": "images/monsters/Green Slime.png",
    "locations": ["The Mines (Floors 1-29)", "The Farm"],
    "lootIds": ["766"],
    "dangerous": false,
    "variants": [
      {
        "name": "Red Slime",
        "hp": 205,
        "damage": 16,
        "speed": 0,
        "xp": 10,
        "image": "images/monsters/Red Slime.png",
        "locations": ["The Mines (Floors 81-119)", "The Farm"],
        "lootIds": ["766"],
        "dangerous": false
      },
      {
        "name": "Purple Slime",
        "hp": 410,
        "damage": 16,
        "speed": 2,
        "xp": 10,
        "image": "images/monsters/Purple Slime.png",
        "locations": ["Skull Cavern", "The Farm"],
        "lootIds": ["766"],
        "dangerous": false
      },
      {
        "name": "Copper Slime",
        "hp": 102,
        "damage": 16,
        "speed": 4,
        "xp": 10,
        "image": "images/monsters/Copper Slime.png",
        "locations": ["Quarry Mine"],
        "lootIds": ["766"],
        "dangerous": false
      },
      {
        "name": "Iron Slime",
        "hp": 205,
        "damage": 16,
        "speed": 1,
        "xp": 10,
        "image": "images/monsters/Iron Slime.png",
        "locations": ["Quarry Mine"],
        "lootIds": ["766"],
        "dangerous": false
      }
    ]
  },
  {
    "id": "Frost Jelly",
    "name": "Frost Jelly",
    "hp": 106,
    "damage": 7,
    "speed": 0,
    "xp": 6,
    "image": "images/monsters/Blue Slime.png",
    "locations": ["The Mines (Floors 41-79)", "The Farm"],
    "lootIds": ["766"],
    "dangerous": false,
    "variants": []
  },
  {
    "id": "Big Slime",
    "name": "Big Slime",
    "hp": 60,
    "damage": 5,
    "speed": 0,
    "xp": 7,
    "image": "images/monsters/Big Slime.png",
    "locations": ["Skull Cavern", "The Mines"],
    "lootIds": ["766"],
    "dangerous": false
  },
  {
    "id": "Tiger Slime",
    "name": "Tiger Slime",
    "hp": 415,
    "damage": 23,
    "speed": 0,
    "xp": 20,
    "image": "images/monsters/Tiger Slime.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": ["766"],
    "dangerous": false
  },
  {
    "id": "Bat",
    "name": "Bat",
    "hp": 24,
    "damage": 6,
    "speed": 0,
    "xp": 3,
    "image": "images/monsters/Bat.png",
    "locations": ["The Mines (Floors 31-39)", "The Farm"],
    "lootIds": ["767"],
    "dangerous": false
  },
  {
    "id": "Frost Bat",
    "name": "Frost Bat",
    "hp": 36,
    "damage": 7,
    "speed": 0,
    "xp": 7,
    "image": "images/monsters/Frost Bat.png",
    "locations": ["The Mines (Floors 41-79)", "The Farm"],
    "lootIds": ["767"],
    "dangerous": false
  },
  {
    "id": "Lava Bat",
    "name": "Lava Bat",
    "hp": 80,
    "damage": 15,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Lava Bat.png",
    "locations": ["The Mines (Floors 81-119)", "Skull Cavern", "The Farm"],
    "lootIds": ["767"],
    "dangerous": false
  },
  {
    "id": "Iridium Bat",
    "name": "Iridium Bat",
    "hp": 300,
    "damage": 30,
    "speed": 0,
    "xp": 22,
    "image": "images/monsters/Iridium Bat.png",
    "locations": ["Skull Cavern", "The Farm"],
    "lootIds": ["768"],
    "dangerous": false
  },
  {
    "id": "Bug",
    "name": "Bug",
    "hp": 1,
    "damage": 8,
    "speed": 0,
    "xp": 1,
    "image": "images/monsters/Bug.png",
    "locations": ["The Mines"],
    "lootIds": ["684"],
    "dangerous": false,
    "variants": [
      {
        "name": "Armored Bug",
        "hp": 1,
        "damage": 8,
        "speed": 2,
        "xp": 1,
        "image": "images/monsters/Armored Bug.png",
        "locations": ["Skull Cavern"],
        "lootIds": ["684"],
        "dangerous": false
      }
    ]
  },
  {
    "id": "Grub",
    "name": "Grub",
    "hp": 20,
    "damage": 4,
    "speed": 0,
    "xp": 2,
    "image": "images/monsters/Grub.png",
    "locations": ["The Mines (Floors 1-29)"],
    "lootIds": ["684"],
    "dangerous": false,
    "variants": [
      {
        "name": "Mutant Grub",
        "hp": 100,
        "damage": 12,
        "speed": 1,
        "xp": 6,
        "image": "images/monsters/Mutant Grub.png",
        "locations": ["Mutant Bug Lair"],
        "lootIds": ["684"],
        "dangerous": false
      }
    ]
  },
  {
    "id": "Fly",
    "name": "Cave Fly",
    "hp": 22,
    "damage": 6,
    "speed": 0,
    "xp": 10,
    "image": "images/monsters/Cave Fly.png",
    "locations": ["The Mines (Floors 1-29)"],
    "lootIds": ["684"],
    "dangerous": false,
    "variants": [
      {
        "name": "Mutant Fly",
        "hp": 66,
        "damage": 12,
        "speed": 2,
        "xp": 10,
        "image": "images/monsters/Mutant Fly.png",
        "locations": ["Mutant Bug Lair"],
        "lootIds": ["684"],
        "dangerous": false
      }
    ]
  },
  {
    "id": "Dust Spirit",
    "name": "Dust Sprite",
    "hp": 40,
    "damage": 6,
    "speed": 0,
    "xp": 2,
    "image": "images/monsters/Dust Sprite.png",
    "locations": ["The Mines (Floors 41-79)"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Ghost",
    "name": "Ghost",
    "hp": 96,
    "damage": 10,
    "speed": 3,
    "xp": 15,
    "image": "images/monsters/Ghost.png",
    "locations": ["The Mines (Floors 41-79)"],
    "lootIds": ["768"],
    "dangerous": false
  },
  {
    "id": "Carbon Ghost",
    "name": "Carbon Ghost",
    "hp": 190,
    "damage": 25,
    "speed": 3,
    "xp": 20,
    "image": "images/monsters/Carbon Ghost.png",
    "locations": ["Skull Cavern"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Putrid Ghost",
    "name": "Putrid Ghost",
    "hp": 500,
    "damage": 25,
    "speed": 3,
    "xp": 25,
    "image": "images/monsters/Putrid Ghost.png",
    "locations": ["Dangerous Mines", "Dangerous Skull Cavern"],
    "lootIds": [],
    "dangerous": true
  },
  {
    "id": "Haunted Skull",
    "name": "Haunted Skull",
    "hp": 160,
    "damage": 15,
    "speed": 3,
    "xp": 15,
    "image": "images/monsters/Haunted Skull.png",
    "locations": ["Quarry Mine", "The Mines"],
    "lootIds": ["768", "769"],
    "dangerous": false
  },
  {
    "id": "Shadow Brute",
    "name": "Shadow Brute",
    "hp": 160,
    "damage": 18,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Shadow Brute.png",
    "locations": ["The Mines (Floors 81-119)", "The Farm"],
    "lootIds": ["769"],
    "dangerous": false
  },
  {
    "id": "Shadow Shaman",
    "name": "Shadow Shaman",
    "hp": 80,
    "damage": 17,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Shadow Shaman.png",
    "locations": ["The Mines (Floors 81-119)", "The Farm"],
    "lootIds": ["769"],
    "dangerous": false
  },
  {
    "id": "Shadow Sniper",
    "name": "Shadow Sniper",
    "hp": 300,
    "damage": 18,
    "speed": 0,
    "xp": 20,
    "image": "images/monsters/Shadow Sniper.png",
    "locations": ["Dangerous Mines"],
    "lootIds": ["769"],
    "dangerous": true
  },
  {
    "id": "Skeleton",
    "name": "Skeleton",
    "hp": 140,
    "damage": 10,
    "speed": 2,
    "xp": 8,
    "image": "images/monsters/Skeleton.png",
    "locations": ["The Mines (Floors 41-79)", "Skull Cavern"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Skeleton Mage",
    "name": "Skeleton Mage",
    "hp": 60,
    "damage": 5,
    "speed": 2,
    "xp": 8,
    "image": "images/monsters/Skeleton Mage.png",
    "locations": ["Dangerous Mines"],
    "lootIds": [],
    "dangerous": true
  },
  {
    "id": "Mummy",
    "name": "Mummy",
    "hp": 260,
    "damage": 30,
    "speed": 3,
    "xp": 20,
    "image": "images/monsters/Mummy.png",
    "locations": ["Skull Cavern"],
    "lootIds": ["768"],
    "dangerous": false
  },
  {
    "id": "Stone Golem",
    "name": "Stone Golem",
    "hp": 45,
    "damage": 5,
    "speed": 0,
    "xp": 5,
    "image": "images/monsters/Stone Golem.png",
    "locations": ["The Mines (Floors 31-39)"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Wilderness Golem",
    "name": "Wilderness Golem",
    "hp": 30,
    "damage": 5,
    "speed": 0,
    "xp": 5,
    "image": "images/monsters/Wilderness Golem.png",
    "locations": ["The Farm"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Iridium Golem",
    "name": "Iridium Golem",
    "hp": 30,
    "damage": 5,
    "speed": 0,
    "xp": 5,
    "image": "images/monsters/Iridium Golem.png",
    "locations": ["The Farm"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Duggy",
    "name": "Duggy",
    "hp": 40,
    "damage": 6,
    "speed": 0,
    "xp": 10,
    "image": "images/monsters/Duggy.png",
    "locations": ["The Mines (Floors 1-29)"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Magma Duggy",
    "name": "Magma Duggy",
    "hp": 380,
    "damage": 16,
    "speed": 0,
    "xp": 18,
    "image": "images/monsters/Magma Duggy.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Rock Crab",
    "name": "Rock Crab",
    "hp": 30,
    "damage": 5,
    "speed": 0,
    "xp": 4,
    "image": "images/monsters/Rock Crab.png",
    "locations": ["The Mines (Floors 1-29)"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Lava Crab",
    "name": "Lava Crab",
    "hp": 120,
    "damage": 15,
    "speed": 0,
    "xp": 12,
    "image": "images/monsters/Lava Crab.png",
    "locations": ["The Mines (Floors 81-119)"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Iridium Crab",
    "name": "Iridium Crab",
    "hp": 240,
    "damage": 15,
    "speed": 0,
    "xp": 20,
    "image": "images/monsters/Iridium Crab.png",
    "locations": ["Skull Cavern"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Truffle Crab",
    "name": "Truffle Crab",
    "hp": 30,
    "damage": 5,
    "speed": 0,
    "xp": 4,
    "image": "images/monsters/Truffle Crab.png",
    "locations": ["The Farm"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Squid Kid",
    "name": "Squid Kid",
    "hp": 1,
    "damage": 18,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Squid Kid.png",
    "locations": ["The Mines (Floors 81-119)"],
    "lootIds": ["768"],
    "dangerous": false
  },
  {
    "id": "Blue Squid",
    "name": "Blue Squid",
    "hp": 80,
    "damage": 18,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Blue Squid.png",
    "locations": ["Dangerous Mines"],
    "lootIds": ["768"],
    "dangerous": true
  },
  {
    "id": "Metal Head",
    "name": "Metal Head",
    "hp": 40,
    "damage": 15,
    "speed": 0,
    "xp": 6,
    "image": "images/monsters/Metal Head.png",
    "locations": ["The Mines (Floors 81-119)"],
    "lootIds": ["768"],
    "dangerous": false
  },
  {
    "id": "Serpent",
    "name": "Serpent",
    "hp": 150,
    "damage": 23,
    "speed": 2,
    "xp": 20,
    "image": "images/monsters/Serpent.png",
    "locations": ["Skull Cavern", "The Farm"],
    "lootIds": ["769"],
    "dangerous": false
  },
  {
    "id": "Royal Serpent",
    "name": "Royal Serpent",
    "hp": 150,
    "damage": 23,
    "speed": 2,
    "xp": 20,
    "image": "images/monsters/Royal Serpent.png",
    "locations": ["Dangerous Skull Cavern"],
    "lootIds": ["769"],
    "dangerous": true
  },
  {
    "id": "Spider",
    "name": "Spider",
    "hp": 200,
    "damage": 15,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Spider.png",
    "locations": ["Dangerous Mines", "Skull Cavern"],
    "lootIds": ["769"],
    "dangerous": true
  },
  {
    "id": "Pepper Rex",
    "name": "Pepper Rex",
    "hp": 300,
    "damage": 15,
    "speed": 0,
    "xp": 7,
    "image": "images/monsters/Pepper Rex.png",
    "locations": ["Skull Cavern"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Stick Bug",
    "name": "Stick Bug",
    "hp": 700,
    "damage": 20,
    "speed": 3,
    "xp": 4,
    "image": "images/monsters/Stick Bug.png",
    "locations": ["Dangerous Mines"],
    "lootIds": [],
    "dangerous": true
  },
  {
    "id": "Lava Lurk",
    "name": "Lava Lurk",
    "hp": 220,
    "damage": 15,
    "speed": 0,
    "xp": 12,
    "image": "images/monsters/Lava Lurk.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Hot Head",
    "name": "Hot Head",
    "hp": 250,
    "damage": 18,
    "speed": 0,
    "xp": 16,
    "image": "images/monsters/Hot Head.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": ["768"],
    "dangerous": false
  },
  {
    "id": "Magma Sprite",
    "name": "Magma Sprite",
    "hp": 220,
    "damage": 15,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Magma Sprite.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Magma Sparker",
    "name": "Magma Sparker",
    "hp": 310,
    "damage": 15,
    "speed": 0,
    "xp": 17,
    "image": "images/monsters/Magma Sparker.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "False Magma Cap",
    "name": "False Magma Cap",
    "hp": 290,
    "damage": 15,
    "speed": 0,
    "xp": 14,
    "image": "images/monsters/False Magma Cap.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Dwarvish Sentry",
    "name": "Dwarvish Sentry",
    "hp": 300,
    "damage": 18,
    "speed": 0,
    "xp": 15,
    "image": "images/monsters/Dwarvish Sentry.png",
    "locations": ["Volcano Dungeon"],
    "lootIds": [],
    "dangerous": false
  },
  {
    "id": "Prismatic Slime",
    "name": "Prismatic Slime",
    "hp": 1000,
    "damage": 35,
    "speed": 2,
    "xp": 10,
    "image": "images/monsters/Prismatic Slime.gif",
    "locations": ["The Mines", "Quarry Mine", "Skull Cavern"],
    "lootIds": ["766", "74"],
    "dangerous": false,
    "variants": []
  }
]
